// Deep-link route for a specific media asset drawer.
// Navigating to /media/<assetId> opens MediaPage with the drawer pre-opened
// for that asset. The route reads assetId from URL params and seeds it into
// MediaPage's initial drawer state via the initialAssetId prop.
import { createFileRoute } from "@tanstack/react-router";
import { requireRole } from "@/lib/auth/require-role";
import MediaPage from "@/features/media/MediaPage";

export const Route = createFileRoute("/_admin/media/$assetId")({
  beforeLoad: () => requireRole("member"),
  component: MediaAssetRoute,
});

function MediaAssetRoute() {
  const { assetId } = Route.useParams();
  return <MediaPage initialAssetId={assetId} />;
}
